import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const Moulds = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Name' },
    { key: 'mould_type', label: 'Type' },
    { key: 'runner_type', label: 'Runner' },
    { key: 'shot_weight', label: 'Shot Weight (g)' },
    { key: 'runner_weight', label: 'Runner Weight (g)' },
    { key: 'standard_cycle_time', label: 'Std Cycle Time (s)' },
    { key: 'machine_tonnage', label: 'Machine Tonnage' },
    { key: 'is_active', label: 'Status' },
  ];

  const formFields = [
    { name: 'code', label: 'Mould Code', required: true, placeholder: 'MLD001' },
    { name: 'name', label: 'Mould Name', required: true, placeholder: 'Mould Name' },
    { 
      name: 'mould_type', 
      label: 'Mould Type', 
      required: true,
      type: 'select',
      options: [
        { value: 'SINGLE', label: 'Single' },
        { value: 'MULTI', label: 'Multi' },
        { value: 'FAMILY', label: 'Family' },
      ]
    },
    { 
      name: 'runner_type', 
      label: 'Runner Type', 
      type: 'select',
      options: [
        { value: 'COLD', label: 'Cold Runner' },
        { value: 'HOT', label: 'Hot Runner' },
      ]
    },
    { name: 'shot_weight', label: 'Shot Weight (grams)', type: 'number', placeholder: '0.00' },
    { name: 'runner_weight', label: 'Runner Weight per Shot (grams)', type: 'number', placeholder: '0.00' },
    { name: 'standard_cycle_time', label: 'Standard Cycle Time (seconds)', type: 'number', placeholder: '0.00' },
    { name: 'machine_tonnage', label: 'Machine Tonnage', placeholder: '100T' },
    { name: 'description', label: 'Description', type: 'textarea', fullWidth: true },
    { name: 'is_active', label: 'Status', type: 'boolean', defaultValue: true },
  ];

  return (
    <MasterLayout
      title="Moulds"
      endpoint="moulds"
      columns={columns}
      formFields={formFields}
      permissions={['ADMIN', 'PRODUCTION']}
    />
  );
};

export default Moulds;
